// middleware
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { navigationMiddleware } from '../middleware/navigationMiddleware';
import { toggleStatsMiddleware } from '../middleware/toggleStatsMiddleware';

export const getRemainingMiddleware = () => {
    return [navigationMiddleware, toggleStatsMiddleware, changeVehicleConfiguration.middleware];
};
